module.exports = __webpack_public_path__ + "static/img/progress.a8876ef.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/progress.jpg
// module id = 8MmO
// module chunks = 1